import { render } from "./SubscriptionListBlock.vue?vue&type=template&id=5285dc76"
import script from "./SubscriptionListBlock.vue?vue&type=script&lang=js"
export * from "./SubscriptionListBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__